import {useArtifactVersionMetricValues} from './artifactMetricData';
import {isArtifactVersionMetricDualMetricScatter} from './artifactVersionMetricChartUtils';
import {
  type ArtifactVersionMetricPlotModel,
  buildArtifactVersionMetricPlotModel,
} from './artifactVersionMetricPlotModel';
import type {ArtifactVersionMetricPanelConfig} from './types';

export function useArtifactVersionMetricPlotModel({
  artifactCollectionId,
  config,
  hasSelection,
  membershipIds,
}: {
  artifactCollectionId?: string;
  config: ArtifactVersionMetricPanelConfig;
  hasSelection: boolean;
  membershipIds: string[];
}): ArtifactVersionMetricPlotModel {
  const isDualMetricScatter = isArtifactVersionMetricDualMetricScatter(config);

  const yMetricData = useArtifactVersionMetricValues({
    artifactCollectionId,
    membershipIds,
    metricName: config.metricName,
  });
  const xMetricData = useArtifactVersionMetricValues({
    artifactCollectionId,
    membershipIds,
    metricName: config.xMetricName,
    enabled: isDualMetricScatter,
  });

  return buildArtifactVersionMetricPlotModel({
    config,
    hasSelection,
    yMetricData,
    xMetricData,
  });
}
